import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";
import LejeuneCampLejeuneWrapper from "@components/layouts/basecamplejeuneWrapper";
import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";

export default function NextAutoWarrantyHome(): ReactElement {
    return (
        <LejeuneCampLejeuneWrapper footerBgColor="#fff">
            <div className="bg-white">
                <ContactTop iconsFillColor="#bf2628" />
            </div>
            <FormSection iconsFillColor="#bf2628" />
        </LejeuneCampLejeuneWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
